// The replay clock, shared between a room's HUD transport and the stage.
// Mutable on purpose: the scene reads `t` every frame and advances it while
// playing; the HUD re-renders through `bump` when state changes (start /
// pause / seek / speed / stop). `t` is the epoch ms being shown; `active`
// means the room is in replay (paused or playing) and the live wire stands
// still. 24 h at 360× takes four minutes.
export function makeReplay(bump) {
  const r = {
    active: false, playing: false, speed: 360, t: 0, t0: 0, t1: 0,
    setWindow(t0, t1) { r.t0 = t0; r.t1 = t1; if (!r.active) r.t = t1; },
    start(at = null) { r.active = true; r.playing = true; r.t = at ?? (r.t >= r.t1 - 1000 ? r.t0 : r.t); bump?.(); },
    pause() { r.playing = false; bump?.(); },
    toggle() { if (!r.active) r.start(); else if (r.playing) r.pause(); else { r.playing = true; bump?.(); } },
    seek(u) { r.active = true; r.t = r.t0 + Math.max(0, Math.min(1, u)) * (r.t1 - r.t0); bump?.(); },
    stop() { r.active = false; r.playing = false; r.t = r.t1; bump?.(); },
    setSpeed(s) { r.speed = s; bump?.(); },
    u() { return r.t1 > r.t0 ? (r.t - r.t0) / (r.t1 - r.t0) : 1; },
  };
  return r;
}

export const REPLAY_SPEEDS = [60, 360, 1800];
